module.exports = __webpack_public_path__ + "static/media/prv.d682f5ac.svg";